import React from "react";
import "./BaseInput.scss";
import { InputLabel, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const CustomTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    maxHeight: '35px', 
    fontSize: '14px',
  },
});

const CustomDatePicker = styled(DatePicker)({
  '& .MuiInputBase-root': {
    maxHeight: '35px', 
    fontSize: '14px',
  },
})

const CustomDateTimePicker = styled(DateTimePicker)({
  '& .MuiInputBase-root': {
    maxHeight: '35px',
    fontSize: '14px',
  },
});

const BaseInput = React.forwardRef((props, ref) => {

  return (
    <>
      <div className="base-input">
        <InputLabel className="label-header" sx={{
          fontWeight: '800', 
          lineHeight: '33.6px',
          color: '#6b7280',
          fontFamily: 'Nunito',
          fontSize: '14px',
          fontStyle: 'normal',
        }}>
          {props.label}
        </InputLabel>
        <div>
          {props.type === "date" ?
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <CustomDatePicker
                  onChange={(newDate) => {
                    if (newDate && !isNaN(newDate)) {
                      props.setValue(props.name, newDate)
                    }
                  }}
                  inputFormat="yyyy/MM/dd"
                  onBlur={props.onBlur}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      borderRadius: '4px',
                      padding: '4px 8px',
                      height: '35px',
                    },
                  }}
                />
              </LocalizationProvider>
            :
            props.type === "datetime" ?
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <CustomDateTimePicker
                  onChange={(newDate) => {
                    if (newDate && !isNaN(newDate)) {
                      props.setValue(props.name, newDate)
                    }
                  }}
                  inputFormat="yyyy/MM/dd HH:mm:ss"
                  onBlur={props.onBlur}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      borderRadius: '4px',
                      padding: '4px 8px',
                      height: '35px',
                    },
                  }}
                />
              </LocalizationProvider>
            :
              <CustomTextField
                ref={ref}
                {...props}
                label=""
                className={`select-style ${props.errorMessage ? "red-border" : ""}`}
                disabled={props.disabled ? true : false}
                variant="outlined" 
                sx={{
                  width: '100%',
                  '& .MuiInputBase-root': {
                    borderRadius: '4px',
                    padding: '4px 8px',
                  },
                }}
              />}
        </div>
      </div>
    </>
  );
});

export default BaseInput;
